import type { ReportBlock } from '@/lib/types/report'
import type { ActivityWithExchanges } from '@/lib/types/project-graph'
import { GraphBlock } from './GraphBlock'

// Adapter that maps a generic ReportBlock's data onto GraphBlock. Kept in its
// own file so registry.tsx exports only the BLOCK_REGISTRY constant
// (react-refresh/only-export-components).
export const ProjectGraphBlock = ({ block }: { block: ReportBlock }) => (
  <GraphBlock activities={(block.data.activities as ActivityWithExchanges[]) ?? []} />
)
